import { createPinia } from 'pinia'

const pinia = createPinia()

export default pinia

export * from './app'
export * from './team'
export * from './match'
export * from './user'
